<template>
    <div class="calendar__proof text-center" :class="{ 'in-dialog': inDialog }">
        <template v-if="proofAsImage">
            <template v-if="!proofError">
                <div class="mt-50" v-loading="true" v-if="!base64"></div>
                <img
                    v-else
                    slot="image"
                    class="w-full"
                    :src="base64"
                    style="max-width: 1500px"
                />
            </template>
            <el-alert
                :closable="false"
                v-else
                title="Error loading proof."
                type="error"
            >
            </el-alert>
        </template>
        <div class="mt-10" id="printable" ref="printable" v-else>
            <div ref="screenshotContainer">
                <div id="proof-pdf">
                    <i class="mdi mdi-loading mdi-spin"></i>
                    <p class="text-center" style="z-index: 1000">
                        Generating Proof...
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VueLoadImage from "vue-load-image";

const Buffer = require("safe-buffer").Buffer;

export default {
    props: {
        calendar: {
            type: Object,
            required: true,
        },
        withTemplate: {
            type: Boolean,
            default: true,
        },
        inDialog: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        VueLoadImage,
    },
    data() {
        return {
            screenshot: null,
            pdf_url: null,
            base64: null,
            proofError: false,
        };
    },
    computed: {
        url() {
            return `/web-api/calendar/${this.calendar.id}/proof?template=${
                this.withTemplate ? 1 : 0
            }&save=1`;
        },
        proofAsImage() {
            if (this.calendar.is_weekly) {
                return false;
            }
            return this.withTemplate
                ? this.$store.state.config.settings
                      .calendar_proof_with_template_as_image
                : this.$store.state.config.settings.calendar_proof_as_image;
        },
    },
    mounted() {
        if (!this.proofAsImage) {
            PDFObject.embed(this.url, "#proof-pdf");
        } else {
            axios
                .get(this.url, {
                    responseType: "arraybuffer",
                })
                .then((response) => {
                    this.base64 = `data:${response.headers[
                        "content-type"
                    ].toLowerCase()};base64,${Buffer.from(
                        response.data,
                        "binary",
                    ).toString("base64")}`;
                })
                .catch((e) => {
                    console.log("CalendarProof:mounted", e);
                    this.proofError = true;
                });
        }
        Bus.$emit("updateScroller");
    },
};
</script>

<style lang="scss" scoped>
#printable {
    position: relative;
    text-align: center;
}

.pdfobject-container {
    height: calc(100vh - 233px);
}

.in-dialog {
    .pdfobject-container {
        height: calc(100vh - 145px);
    }
}

.mdi-loading {
    font-size: 40px;
}
</style>
